var map = {
	"./ fundingCenter.js": 50131,
	"./audit.js": 96102,
	"./commodity.js": 89699,
	"./dashboard.js": 14404,
	"./examine.js": 73980,
	"./finance.js": 17003,
	"./marketing.js": 78893,
	"./member.js": 38722,
	"./merchantStore.js": 27229,
	"./order.js": 58728,
	"./permission.js": 75285,
	"./platform.js": 25554,
	"./platformOperationsCenter.js": 50187,
	"./platformstore.js": 15594,
	"./purchaseOrder.js": 49391,
	"./sampleManagement.js": 66757,
	"./setting.js": 50082,
	"./shop.js": 42870,
	"./statistics.js": 93777,
	"./store.js": 74822,
	"./workOrders.js": 60814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80881;